// Standalone so `routeURLs` can build the templates path without importing
// `TaskListContainer` (which imports `routeURLs`), avoiding a load-order cycle.
export enum TASK_LIST_TABS {
  TASKS = 'tasks',
  TEMPLATES = 'templates',
}
